import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TendersComponent } from './tenders.component';
import { CommonModule } from '@angular/common';

import { ExploreByKeywordsTendersComponent } from './../explore-by-keywords/explore-by-keywords.component';
import { ExploreByAuthorityTendersComponent } from './../explore-by-authority/explore-by-authority.component';
import { ExploreByStatesTendersComponent } from './../explore-by-states/explore-by-states.component';
import { SlickSliderModule } from './../slick-slider/slick-slider.module';

import { SearchBarModule } from "src/app/modules/shared/_components/search-bar/search-bar.module";
import { KeywordsSectionModule } from './../keywords-section/keywords-section.module';

// import { TendersResolver } from 'src/app/_utils/_resolvers/main-data.resolver';
import { SharedModule } from './../../../shared/shared.module';

import { ReactiveFormsModule } from '@angular/forms';
import { NewlyAddedTendersComponent } from '../newly-added-tenders/newly-added-tenders.component';

import { WordSlicePipesModule } from '../../_pipes/word-slice.pipe.module';
import { PipesModule } from '../../_pipes/amount-pipes.module';

import { ThankYouPageModule } from 'src/app/modules/shared/_components/thankyou-modal/thankyou-modal.module';

import { SkeletonLoaderModule } from 'src/app/modules/tenders/_modals/SkeletonLoader/skeleton-loader.module';
import { FaqListingPageModule } from './../../../shared/_components/faq-lisiting/faq-listing-page.module';

const routes: Routes = [
  {
    path: '',
    component: TendersComponent,
    // resolve: { tendersResolver: TendersResolver }
  }
];

@NgModule({
  declarations: [
    TendersComponent,
    ExploreByKeywordsTendersComponent,
    ExploreByAuthorityTendersComponent,
    ExploreByStatesTendersComponent,
    NewlyAddedTendersComponent,
  ],
  imports: [RouterModule.forChild(routes),
    CommonModule,
    SharedModule,
    SearchBarModule,
    KeywordsSectionModule,
    ReactiveFormsModule,
    WordSlicePipesModule,
    PipesModule,
    SlickSliderModule,
    SkeletonLoaderModule,
    FaqListingPageModule,
    ThankYouPageModule
  ],
  exports: [RouterModule]
})
export class MainTendersModule { }
